import { z } from 'zod'

import { durationUnits } from '../courses/course'

/** A course as Find Courses and the course chooser list it, from `GET /catalog/v1/courses`. */
const listingSchema = z.object({
  id: z.string(),
  organizationId: z.string(),
  organizationName: z.string(),
  name: z.string(),
  shortName: z.string().nullish(),
  keywords: z.string().nullish(),
  externalId: z.string().nullish(),
  duration: z.number(),
  durationUnit: z.enum(durationUnits),
  availableInstructorLed: z.boolean(),
  availableSelfPaced: z.boolean(),
  hasLabs: z.boolean(),
  isArchived: z.boolean(),
  createdOn: z.string(),
  modifiedOn: z.string(),
  // Filled in only for who may see the course's prices (CAT-19).
  perLearnerPrice: z.number().nullish(),
  perEventPrice: z.number().nullish(),
  privateLegacyPrice: z.number().nullish(),
  publicLegacyPrice: z.number().nullish(),
})

export type CourseListing = z.infer<typeof listingSchema>

export function parseCourseListing(item: unknown): CourseListing {
  return listingSchema.parse(item)
}
